export default "__VITE_ASSET__1b44715c__"